import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { UserRoles } from '@authentication/user-roles';
import { AuthService } from '@services/auth.service';
import { filter } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export const roleGuardFn = (
  activatedRoute: ActivatedRouteSnapshot,
  routerState: RouterStateSnapshot
) => {
  const msalService = inject(MsalService);
  const authService = inject(AuthService);
  const broadcastService = inject(MsalBroadcastService);
  const router = inject(Router);
  const url = routerState.url;

  return broadcastService.inProgress$.pipe(
    filter((status: InteractionStatus) => status === InteractionStatus.None),
    map(() => {
      const user = msalService.instance.getActiveAccount();
      if (!user || user.idTokenClaims === undefined) {
        window.location.href = window.location.origin;
        return false;
      }

      if (url.startsWith('/unboundorders')) {
        window.location.href = window.location.origin + '/order-new/start';
        return false;
      }

      const allowedRoles: UserRoles[] = activatedRoute.data['roles'] ?? [];
      const requireBillingEnabled: boolean = activatedRoute.data['requireBillingEnabled'] ?? false;
      const requireMatchingGarageId: boolean =
        activatedRoute.data['requireMatchingGarageId'] ?? false;

      if (requireBillingEnabled && !environment.enableBilling) {
        router.navigate(['/page-not-found']);
        return false;
      }

      if (!authService.userHasAnyRole(allowedRoles)) {
        router.navigate(['/page-not-found']);
        return false;
      }

      if (requireMatchingGarageId) {
        const scId = activatedRoute.paramMap.get('subcontractorId');
        const garageIdMatches = scId === null || scId === user.idTokenClaims.garageIds[0];
        if (!garageIdMatches) {
          router.navigate(['/page-not-found']);
          return false;
        }
      }

      return true;
    })
  );
};
